
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  position:relative;
  padding-bottom:0px;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

:host([height-grow]) {
  display:grid;
  height:100%;
}

:host([height-grow]) .card, :host([height-grow]) .card-wrapper {
  height:100%;
}

.card-wrapper {
  display:flex;
  flex-direction:column;
  background-image:var(--bh-gradient-gray-bl-tr);
}

.card-wrapper .card {
  border-radius:0.5rem;
}

.card-wrapper .card {
  border-width:1px;
}

.card-wrapper .card {
  border-style:solid;
}

.card-wrapper .card {
  border-color:var(--neutral-transparent);
}

.card-wrapper.is-hovered {
  cursor:pointer;
}

.card-wrapper.is-hovered {
  background-image:var(--bh-gradient-lightblue-bl-tr);
}

.card-wrapper.is-hovered .card {
  border-color:var(--bh-neutral-white);
}

.card-wrapper.is-hovered .card-large-icon {
  opacity:0.2;
}

.card {
  margin:1.5rem;
  display:flex;
  height:100%;
  flex-direction:column;
  align-items:center;
}

.card-body-wrapper {
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:0.75rem;
  padding-top:1.5rem;
  padding-bottom:1.5rem;
  padding-left:1.25rem;
  padding-right:1.25rem;
}

@media (min-width: 1024px) {

  .card-body-wrapper {
    gap:1rem;
  }

  .card-body-wrapper {
    padding-top:7rem;
    padding-bottom:7rem;
  }
}

.card-content {
  max-width:251px;
  padding-left:3rem;
  font-family:var(--bh-ff-body);
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
  z-index:2;
}

.card-cta {
  font-family:var(--bh-ff-body);
  z-index:2;
}

.card-icon {
  position:relative;
  flex:none;
  align-items:center;
  justify-content:center;
  color:var(--bh-brand-primary-default);
  z-index:2;
}

.card-large-icon {
  position:absolute;
  margin:1.5rem;
  margin-left:auto;
  margin-right:auto;
  height:75%;
  max-width:20rem;
  color:var(--bh-neutral-white);
}

.card-large-icon ghs-icon {
  margin:1.5rem;
}

.card-large-icon ghs-icon {
  height:75%;
}

.card-large-icon {
  z-index:1;
}
`;